import { normaliseHospitalInfo } from './hospitalInfo';
import { normalizeEnabledLanguageIds } from '../../../src/i18n/languages.js';

const STORAGE_KEY = 'kyc_studio_trust_config_v2';
const LEGACY_KEY = 'kyc_studio_trust_config_v1';

function safeParse(value) { try { return value ? JSON.parse(value) : null; } catch { return null; } }
function validObject(value) { return value && typeof value === 'object' && !Array.isArray(value); }

function readAll() {
  const current = safeParse(localStorage.getItem(STORAGE_KEY));
  if (validObject(current)) return current;
  const legacy = safeParse(localStorage.getItem(LEGACY_KEY));
  if (validObject(legacy)) {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(legacy));
    return legacy;
  }
  return {};
}

export function normalizeTrustConfig(trustId, config = {}) {
  return {
    ...config,
    trustId,
    status: config.status || 'draft',
    roles: validObject(config.roles) ? config.roles : {},
    uniforms: validObject(config.uniforms) ? config.uniforms : {},
    careSettings: validObject(config.careSettings) ? config.careSettings : {},
    journeys: validObject(config.journeys) ? config.journeys : {},
    hospitalInfo: normaliseHospitalInfo(config.hospitalInfo),
    enabledLanguages: normalizeEnabledLanguageIds(config.enabledLanguages),
    updatedAt: config.updatedAt || null,
  };
}

export function loadTrustConfig(trustId) {
  const all = readAll();
  return normalizeTrustConfig(trustId, all[trustId]);
}

export function saveTrustConfig(trustId, config) {
  const all = readAll();
  const saved = normalizeTrustConfig(trustId, {
    ...config,
    updatedAt: new Date().toISOString(),
  });
  all[trustId] = saved;
  localStorage.setItem(STORAGE_KEY, JSON.stringify(all));
  return saved;
}

export function importTrustConfig(payload) {
  const candidate = payload?.trustConfiguration || payload;
  if (!validObject(candidate) || !candidate.trustId) throw new Error('The selected file is not a valid Trust configuration export.');
  return saveTrustConfig(candidate.trustId, candidate);
}

export function exportTrustConfig(trustId, config, schemaVersion = 4) {
  const payload = {
    schemaVersion,
    exportedAt: new Date().toISOString(),
    trustConfiguration: normalizeTrustConfig(trustId, config),
  };
  const blob = new Blob([JSON.stringify(payload, null, 2)], { type: 'application/json' });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = `kyc-trust-configuration-${trustId}-${new Date().toISOString().slice(0,10)}.json`;
  a.click();
  setTimeout(() => URL.revokeObjectURL(url), 0);
}
